(function () {
  "use strict";

  function elements(root, selector) {
    var scope = root || document;
    var matches = Array.from(scope.querySelectorAll(selector));
    if (scope.nodeType === 1 && scope.matches(selector)) matches.unshift(scope);
    return matches;
  }

  function scrollRoot() {
    var page = document.querySelector(".page-wrapper");
    if (page && page.scrollHeight > page.clientHeight + 40) return page;
    return document.scrollingElement || document.documentElement;
  }

  function initGalleries(root) {
    elements(root, "[data-cl-gallery]").forEach(function (gallery) {
      if (gallery.dataset.clBound === "true") return;
      gallery.dataset.clBound = "true";

      var slides = Array.from(gallery.querySelectorAll("[data-cl-slide]"));
      var frame = gallery.querySelector(".cl-gallery__main");
      var thumbRail = gallery.querySelector(".cl-gallery__thumbs");
      var thumbs = Array.from(gallery.querySelectorAll("[data-cl-thumb]"));
      var previous = gallery.querySelector("[data-cl-gallery-prev]");
      var next = gallery.querySelector("[data-cl-gallery-next]");
      var activeIndex = slides.findIndex(function (slide) { return slide.classList.contains("is-active"); });
      if (activeIndex < 0) activeIndex = 0;

      function syncFrame(index) {
        if (!frame || frame.getAttribute("data-cl-adaptive-ratio") === "false") return;
        var slide = slides[index];
        var media = slide && slide.querySelector("img, video");
        if (!media) return;

        function applyRatio() {
          var width = media.tagName === "VIDEO" ? media.videoWidth : media.naturalWidth;
          var height = media.tagName === "VIDEO" ? media.videoHeight : media.naturalHeight;
          if (width > 0 && height > 0) frame.style.aspectRatio = width + " / " + height;
        }

        if (media.tagName === "VIDEO") {
          if (media.readyState >= 1) applyRatio();
          else media.addEventListener("loadedmetadata", applyRatio, { once: true });
        } else if (media.complete) {
          applyRatio();
        } else {
          media.addEventListener("load", applyRatio, { once: true });
        }
      }

      function activate(index) {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === activeIndex;
          slide.classList.toggle("is-active", active);
          if (!active) {
            slide.querySelectorAll("video").forEach(function (video) { video.pause(); });
          }
        });
        thumbs.forEach(function (item, i) {
          item.classList.toggle("is-active", i === activeIndex);
          item.setAttribute("aria-pressed", i === activeIndex ? "true" : "false");
        });
        syncFrame(activeIndex);

        var activeThumb = thumbs[activeIndex];
        if (thumbRail && activeThumb) {
          var target = activeThumb.offsetLeft - (thumbRail.clientWidth - activeThumb.offsetWidth) / 2;
          thumbRail.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
        }
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var index = Number(thumb.getAttribute("data-cl-thumb"));
          activate(index);
        });
      });

      if (previous) previous.addEventListener("click", function () { activate(activeIndex - 1); });
      if (next) next.addEventListener("click", function () { activate(activeIndex + 1); });
      activate(activeIndex);
    });
  }

  function initProofSliders(root) {
    elements(root, "[data-cl-proof-slider]").forEach(function (slider) {
      if (slider.dataset.clBound === "true") return;

      slider.querySelectorAll("[data-cl-proof-media]").forEach(function (frame) {
        if (frame.dataset.clRatioBound === "true") return;
        var media = frame.querySelector("img, video");
        if (!media) return;
        frame.dataset.clRatioBound = "true";

        function applyRatio() {
          var width = media.tagName === "VIDEO" ? media.videoWidth : media.naturalWidth;
          var height = media.tagName === "VIDEO" ? media.videoHeight : media.naturalHeight;
          if (width > 0 && height > 0) frame.style.aspectRatio = width + " / " + height;
        }

        if (media.tagName === "VIDEO") {
          if (media.readyState >= 1) applyRatio();
          else media.addEventListener("loadedmetadata", applyRatio, { once: true });
        } else if (media.complete) {
          applyRatio();
        } else {
          media.addEventListener("load", applyRatio, { once: true });
        }
      });

      var rail = slider.querySelector("[data-cl-proof-rail]");
      var previous = slider.querySelector("[data-cl-proof-prev]");
      var next = slider.querySelector("[data-cl-proof-next]");
      if (!rail || !previous || !next) return;
      slider.dataset.clBound = "true";

      function move(direction) {
        var card = rail.querySelector(".cl-result-card");
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 17;
        var distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: direction * distance, behavior: "smooth" });
      }

      previous.addEventListener("click", function () { move(-1); });
      next.addEventListener("click", function () { move(1); });
    });
  }

  function initBuyboxes(root) {
    elements(root, "[data-cl-buybox]").forEach(function (box) {
      if (box.dataset.clBound === "true") return;
      var form = box.querySelector("[data-cl-form]");
      var variantInput = box.querySelector("[data-cl-variant]");
      var qtyInput = box.querySelector("[data-cl-qty]");
      var submit = box.querySelector("[data-cl-submit]");
      if (!form || !variantInput || !submit) return;
      box.dataset.clBound = "true";

      function syncTier(radio) {
        var variant = radio ? radio.getAttribute("data-variant") : "";
        var qty = radio ? radio.getAttribute("data-qty") : "";
        variantInput.value = variant || "";
        if (qtyInput) qtyInput.value = qty || "1";
        submit.disabled = !variant;
        submit.textContent = variant ? submit.getAttribute("data-ready-label") : submit.getAttribute("data-missing-label");
      }

      box.querySelectorAll("[data-cl-tier]").forEach(function (radio) {
        radio.addEventListener("change", function () { syncTier(radio); });
      });

      form.addEventListener("submit", function (event) {
        if (!variantInput.value) event.preventDefault();
      });

      syncTier(box.querySelector("[data-cl-tier]:checked"));
    });
  }

  function initScrollButtons(root) {
    elements(root, "[data-cl-scroll]").forEach(function (button) {
      if (button.dataset.clBound === "true") return;
      button.dataset.clBound = "true";
      button.addEventListener("click", function (event) {
        var selector = button.getAttribute("data-cl-scroll");
        var target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector("[data-cl-sticky]");
    var heroButton = document.querySelector("[data-cl-hero-cta]");
    if (!sticky || !heroButton || sticky.dataset.clBound === "true") return;
    sticky.dataset.clBound = "true";

    var root = scrollRoot();
    var eventTarget = root === document.documentElement ? window : root;
    var updateSticky = function () {
      var rect = heroButton.getBoundingClientRect();
      sticky.classList.toggle("is-visible", rect.bottom < 0);
    };
    eventTarget.addEventListener("scroll", updateSticky, { passive: true });
    updateSticky();
  }

  function init(root) {
    initGalleries(root);
    initProofSliders(root);
    initBuyboxes(root);
    initScrollButtons(root);
    initSticky();
  }

  init(document);
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
